import { fetchDevicesData, removeDeviceOwnership } from '@/api/api.APP_TARGET';

const getDeviceData = ({ state, commit }) => {
  if (state.promise) return state.promise;
  const fetchPromise = fetchDevicesData().then((deviceData) => {
    commit('SET_DEVICE_DATA', deviceData);
  });
  commit('SET_PROMISE', fetchPromise);
  return fetchPromise;
};

const clearDeviceData = ({ commit }) => {
  commit('SET_PROMISE', null);
};

const setDeviceData = ({ commit }, payload) => {
  commit('SET_DEVICE_DATA', payload);
};

const updateDeviceData = ({ commit }, payload) => {
  commit('UPDATE_DEVICE_DATA', payload);
};

const deregisterDevice = ({ commit }, payload) => {
  return removeDeviceOwnership(payload.dev_id);
};

export default {
  getDeviceData,
  setDeviceData,
  clearDeviceData,
  updateDeviceData,
  deregisterDevice,
};
